import configs from '@/config'

const identifyUser = ({ email }) => {
  window.sib.email_id = email
}

const trackEvent = (eventName, properties, eventData = {}) => {
  if (!eventName) return

  const newEventName = `${configs.env}_${eventName}`
  window.sendinblue.track(newEventName, properties, { data: eventData })
}

export default {
  trackEvent,
  identifyUser,
}
